import { render, staticRenderFns } from "./team.invite.vue?vue&type=template&id=00093131&scoped=true&"
import script from "./team.invite.vue?vue&type=script&lang=js&"
export * from "./team.invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00093131",
  null
  
)

export default component.exports